export default __webpack_public_path__ + "static/media/ro3.95d364d4.jpg";